import { Box, ButtonBase } from "@mui/material";
import React from "react";
import { PAYMENT_METHODS } from "../../constants/enums";
import Iconify from "../iconify/Iconify";
import "./OrderPaymentOptions.css";

function OrderPaymentOptions({
  actionType,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
}) {
  const boxClass = `${
    actionType === "COUNTER"
      ? "menu-item-payment-btns-counter"
      : "menu-item-payment-btns"
  }`;

  return (
    <>
      <Box className={boxClass}>
        {Object.values(PAYMENT_METHODS).map((method) => {
          return (
            <ButtonBase
              key={method.value}
              className={`menu-item-payment-btn ${
                selectedPaymentMethod?.value === method.value ? "active" : ""
              } ${
                actionType === "COUNTER" ? "menu-item-payment-btn-counter" : ""
              }`}
              onClick={() => setSelectedPaymentMethod(method)}
            >
              <Box className="payment-content">
                <Iconify icon={method.icon} />
                <Box>{method.label}</Box>
              </Box>

              {selectedPaymentMethod?.value === method.value && (
                <Box className="payment-check-icon">
                  <Iconify icon="mdi:check-circle" />
                </Box>
              )}
            </ButtonBase>
          );
        })}
      </Box>
    </>
  );
}

export default OrderPaymentOptions;
